import _ from 'lodash';
import { useEffect } from 'react';
import { connect } from 'react-redux';
import { useParams } from 'react-router-dom';
import uuid from 'react-uuid';

import {
  addANewField,
  setFormTemplateValue,
  setActiveAccordion,
  setInactiveAccordion,
} from '../../redux/actions/formTemplateActions';
import { updateFormTemplateRequest, setFormTemplatesError } from '../../redux/actions/formTemplateApiActions';
import LoadingApiPlaceholder from '../presentational/LoadingApiPlaceholder/LoadingApiPlaceholder';
import FormTemplateFormContainer from './FormTemplateFormContainer';

export function EditTemplateContainer(props) {
  const {
    addANewField,
    setFormTemplateValue,
    setActiveAccordion,
    setInactiveAccordion,
    formTemplateVersion,
    updateFormTemplateRequest,
    formTemplateRequest,
    defaultFormTemplateField,
    setFormTemplatesError,
  } = props;

  const { templateId } = useParams();
  const { loading, requestType } = formTemplateRequest;

  useEffect(() => {
    setInactiveAccordion([]);
  }, []);

  useEffect(() => {
    return () => {
      if (requestType) setFormTemplatesError({}, null);
    };
  }, [requestType]);

  const addAField = () => {
    const id = uuid();
    addANewField({ ..._.cloneDeep(defaultFormTemplateField), id });
    setActiveAccordion(id);
  };

  const handleTemplateChange = (value, templateAttributeId) => {
    setFormTemplateValue(templateAttributeId, value);
  };

  const editFormTemplateRender = () => {
    if (loading) {
      return <LoadingApiPlaceholder layout="editFormTemplate" />;
    }
    return (
      <>
        {!loading && (
          <FormTemplateFormContainer
            formTemplate={formTemplateVersion}
            handleTemplateChange={handleTemplateChange}
            addAField={addAField}
            handleFormAction={updateFormTemplateRequest}
            setActiveAccordion={setActiveAccordion}
            formId={Number(templateId)}
            setFormTemplatesError={setFormTemplatesError}
          />
        )}
      </>
    );
  };

  return <>{editFormTemplateRender()}</>;
}

const mapStateToProps = (state) => {
  return {
    formTemplateVersion: state.formTemplateReducer.formTemplateVersion,
    formTemplateRequest: state.formTemplateApiReducer.formTemplateRequest,
    defaultFormTemplateField: state.formTemplateApiReducer.defaultFormTemplate?.versions[0].fields[0],
  };
};

const mapDispatchToProps = {
  addANewField,
  updateFormTemplateRequest,
  setActiveAccordion,
  setInactiveAccordion,
  setFormTemplateValue,
  setFormTemplatesError,
};

export default connect(mapStateToProps, mapDispatchToProps)(EditTemplateContainer);
